/**
 * Sistema de logging condicional
 * Logs aparecem APENAS em desenvolvimento
 */

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
  
  info: (...args: any[]) => {
    if (isDev) console.info(...args);
  },
  
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },
  
  // ✅ Errors sempre aparecem (produção também)
  error: (...args: any[]) => {
    console.error(...args);
  },
  
  // Para debug pesado (desabilitado por padrão)
  debug: (...args: any[]) => {
    if (isDev && import.meta.env.VITE_DEBUG_MODE === 'true') {
      console.log('[DEBUG]', ...args);
    }
  }
};
